import { useSessionData } from '@confluence/session-data/entry-points/useSessionData.ts';

export const useIsPageEligibleForAdminAnnouncementBanner = () => {
	const { edition } = useSessionData();
	return edition === 'PREMIUM' || edition === 'STANDARD';
};
